import React, { useState, useEffect, createContext } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "react-checkbox-tree-enhanced/lib/react-checkbox-tree.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Login from "./pages/Login";
import NewLogin from "./pages/Loginnew";
import ForgotPassword from './pages/ForgotPassword';
import ThemeSelector from "./themes/ThemeSelectorComponent/ThemeSelector";
import Dashboard from "./pages/NewDashboard/Dashboard";
import ReportDashboard from "./pages/ReportDashboard/ReportDashboard";
// import InternalK1 from "./pages/InternalK1/InternalK1";
import InternalK1 from "./pages/internalK1-ts/internalK1";
import Tieout from "pages/tieout-ts/tieout";
import ClientOnboardingConfigFlow from "./separate_apps/ClientOnboarding/clientonboardingconfigflow";
import MyKones from "./pages/K1/K1LandingPage/konehome";
import LandingPage from "pages/LandingPage/LandingPage";
import TermsOfService from "./pages/terms_of_service/TermsOfService/TermsOfService";


function App(props) {
  const [basic, setBasic] = useState(false);
  const activeFeatures = props.activeFeatures
  // console.log("OS VARIABLE ENV: ", process.env)
  // console.log("BASIC feature: ", basic)
  useEffect(() => {
    if ((activeFeatures != [] && activeFeatures != null) && activeFeatures.includes("Level 1 Support")) {
      setBasic(true)
    }
  }, [activeFeatures])

  return (
    <>
      <Routes>
        <Route path={"/login"} element={<NewLogin />}></Route>
        <Route path={"/login2"} element={<NewLogin />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path={"/login"} element={<NewLogin />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
         <Route path={"/"} element=
          {
          <MyKones />
          }
          >
          </Route>
        <Route path={""} element=
        {

        <MyKones />

        }
        ></Route>
       {" "}
        : <Route path={"/login"} element={<NewLogin />}></Route>
        <Route path={"/"} element={<ReportDashboard />}></Route>
        <Route path={""} element={<ReportDashboard />}></Route>
        <Route path={"/dashboard"} element={<Dashboard />}></Route>
        
  
        <Route path={"/clientonboarding"} element={<ClientOnboardingConfigFlow />}></Route>
        <Route path={"/themes"} element={<ThemeSelector />}></Route>
        <Route path={"/internalk1"} element={<InternalK1 />}></Route>
        <Route path={"/tieout"} element={<Tieout />}></Route>
        <Route path='/landing' element={<LandingPage />} />
      </Routes>
    </>
  );
}

export default App;
